import React, { useEffect, useCallback } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useSelector, useDispatch } from 'react-redux';
import { Capacitor } from '@capacitor/core';
import Echo from '../../plugins/echo/echo';
import { iosPlugin } from '../../plugins/iosPlugin/iosPlugin';
import { closeInAppNoti } from '../../Reducer/InAppNotiReducer';
import Icon from '../../Assets/Icon/CustomIcon';
import NOTI_PRESET from '../../Presets/NotiPreset';
import { BaseInfoActions } from '../../Reducer/BaseInfoReducer';
import { useAppNavigate } from '../../Hooks/back/useAppNavigate';

const ICON_MAP = {
  Alarm: <Icon.Alarm />,
};

export default function InAppNoti() {
  const dispatch = useDispatch();
  const { open, title, message, icon, gubun, responseData } = useSelector(
    (state) => state.inAppNoti
  );
  const { userInfo } = useSelector((state) => state.BaseInfo);
  const [statusBar, setStatusBar] = React.useState(0);
  const { navigate } = useAppNavigate();

  const clearAllNotiState = useCallback(() => {
    dispatch(closeInAppNoti());
    dispatch(BaseInfoActions.setFcmReceptionPayload({}));
  }, [dispatch]);

  useEffect(() => {
    getDeviceEdge();
  }, []);

  const getDeviceEdge = async () => {
    if (Capacitor.isNativePlatform()) {
      if (Capacitor.getPlatform() === 'android') {
        const result = await Echo.getSystemBarInsets();
        setStatusBar(result.statusBarHeight || 0);
      } else if (Capacitor.getPlatform() === 'ios') {
        const result = await iosPlugin.getSystemBarInsets();
        setStatusBar(result.statusBarHeight || 0);
      }
    }
  };

  useEffect(() => {
    if (open) {
      const timer = setTimeout(() => {
        clearAllNotiState();
      }, 4000);
      return () => clearTimeout(timer);
    }
  }, [open, clearAllNotiState]);

  const handleClick = () => {
    const preset = NOTI_PRESET[gubun] || NOTI_PRESET.default;
    const url = preset.buildRoute(responseData, userInfo);

    console.log('🚀 프리셋에서 결정된 URL:', url);

    if (url) {
      navigate(url);
    }

    clearAllNotiState();
  };

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          initial={{ y: -120, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: -120, opacity: 0 }}
          transition={{ type: 'spring', stiffness: 300, damping: 25 }}
          onClick={handleClick}
          style={{
            position: 'fixed',
            top: statusBar + 8,
            left: 0,
            right: 0,
            margin: '0 auto',
            width: '92%',
            background: '#333',
            color: '#fff',
            borderRadius: 12,
            padding: '12px 14px',
            display: 'flex',
            alignItems: 'center',
            gap: 12,
            zIndex: 3000,
            boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
            cursor: 'pointer',
            opacity: 0.95,
          }}
        >
          <div
            style={{
              width: 40,
              height: 40,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            {ICON_MAP[icon || 'Alarm']}
          </div>

          <div style={{ flex: 1 }}>
            <div style={{ fontWeight: 'bold', fontSize: 14 }}>{title}</div>
            <div style={{ fontSize: 13, opacity: 0.9 }}>{message}</div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
